import { motion } from 'framer-motion';
import { useLang } from '@/context/LanguageContext';
import { UI_TEXT } from '@/data/tradeData';

const ABOUT_IMG = "https://images.pexels.com/photos/4981775/pexels-photo-4981775.jpeg";

export default function About() {
  const { lang } = useLang();
  const t = UI_TEXT[lang].about;

  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32 border-t border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="lg:col-span-7">
            <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#E31937] mb-4">{t.label}</p>
            <h2 className="font-display font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-white mb-6">{t.title}</h2>
            <p className="text-base leading-relaxed text-[#A3A3A3] mb-5 max-w-lg">{t.p1}</p>
            <p className="text-base leading-relaxed text-[#A3A3A3] max-w-lg">{t.p2}</p>
            <div className="mt-10 flex flex-wrap gap-x-12 gap-y-6">
              {t.stats.map(s => (
                <div key={s.label}>
                  <p className="font-display font-black text-3xl sm:text-4xl text-[#E31937]">{s.value}</p>
                  <p className="text-xs uppercase tracking-widest text-[#A3A3A3] mt-1">{s.label}</p>
                </div>
              ))}
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.15 }} className="lg:col-span-5 relative">
            <div className="absolute -bottom-4 -left-4 w-full h-full bg-[#E31937]/15 hidden lg:block" />
            <div className="relative overflow-hidden"><img src={ABOUT_IMG} alt="Contractor" className="w-full h-[400px] lg:h-[500px] object-cover" loading="lazy" /></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
